/*
*   CRITICAL Changes:
*   1.  Refactored Initial Data Loading `useEffect`: The first `useEffect` hook, responsible for loading the initial assignment data, has been optimized.
*       Before, I had it so that if location.state is null, it'd fetch the assignment with submission. For some reason, the location.state would not be null
*       upon page refresh, so I just did away with it completely, lol.
*   2.  No Change to Socket `useEffect`. Everything looked good there.
*/

import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import styles from './styles/ClassroomViewer.module.css';
import ClassroomCanvasOptions from './ClassroomCanvasOptions';
import CanvasContext from '../../../context/CanvasContext';
import ClassroomCanvas from './ClassroomCanvas';
import socket from './../../../socket';
import ClassroomCanvasSidebar from './ClassroomCanvasSidebar';

const ClassroomCanvasViewer = () => {
    const { classroomId, scenarioId, assignmentId } = useParams();
    // const location = useLocation();
    const {
        fetchAssignmentSubmissions,
        assignmentWithSubmissions,
        // setAssignmentWithSubmissions,
        fetchClassroomScenarioLogs,
    } = useContext(CanvasContext);

    const [activeStudents, setActiveStudents] = useState([]);
    const [sortedStudents, setSortedStudents] = useState([]);
    
    // const sortForActiveStudents = useCallback(() => {
    //     const activeIds = new Set(activeStudents.map(s => s.id));

    //     setSortedStudents([...assignmentWithSubmissions?.students].sort((a, b) =>
    //         Number(!activeIds.has(a._id)) - Number(!activeIds.has(b._id))
    //     ));

    //     console.log("lebron",sortedStudents);
    //     // const sortedStudents = [...assignmentWithSubmissions.students].sort((a, b) =>
    //     //     Number(!activeIds.has(a._id)) - Number(!activeIds.has(b._id))
    //     // );
    // }, [assignmentWithSubmissions, activeStudents]); 

    useEffect(() => {
        if (assignmentId) {
            fetchAssignmentSubmissions();
        } else if (classroomId && scenarioId) {
            fetchClassroomScenarioLogs();
        }
    }, [assignmentId]); // This effect should ONLY re-run when the assignment itself changes.

    useEffect(() => {
        if (!socket || !assignmentId) {
            return;
        }

        const logConnection = () => console.log("Socket connected: ", socket.id);
        const logError = (err) => console.error("Socket connection error: ", err);
        const handleActiveUpdate = (studentList) => {
            setActiveStudents(studentList);

                //sortForActiveStudents();
        }

        socket.on("connect", logConnection);
        socket.on("connect_error", logError);

        socket.emit('joinAsTeacher', { assignmentId });
        socket.on('activeStudentsUpdate', handleActiveUpdate);

        const handleSubmissionUpdate = (data) => {
            console.log('%c[Socket] Submission update received!', 'color: lime; font-weight: bold;', data);
            fetchAssignmentSubmissions();
        };

        socket.on('submissionUpdated', handleSubmissionUpdate);

        const handleStartPageUpdate = (data) => {
              console.log("handle", data);
            if(Object.values(data.situationId)[0]){
                setActiveStudents(prevStudents => 
                    prevStudents.map(student => 
                        student.userId === data.studentId
                        ? {...student, situationId: data.situationId, startStatus: false}
                        : student
                    )
                );
            }
        };

        socket.on('startPageUpdate', handleStartPageUpdate);
        return () => {
            socket.off("connect", logConnection);
            socket.off("connect_error", logError);
            socket.off('activeStudentsUpdate', handleActiveUpdate);
            socket.off('submissionUpdated', handleSubmissionUpdate);
            socket.off('startPageUpdate', handleStartPageUpdate);
        };
    }, [socket, assignmentId, fetchAssignmentSubmissions]);

    const [selectedUser, setSelectedUser] = useState(null);

    const handleSelectedUser = useCallback((student) => {
        setSelectedUser(student);
    }, [selectedUser])

    return (
        <div className={styles.container}>
            {selectedUser && 
                <div className={styles.createNodeSidebar}>
                    <ClassroomCanvasOptions userInfo = {selectedUser}/>
                </div>
            }
            <div className={styles.canvas}>
                <ClassroomCanvas />
            </div>
            <div className={styles.sidebar}>
                <ClassroomCanvasSidebar activeStudents={activeStudents} selectedUserPropFunction = {handleSelectedUser}/>
            </div>
        </div>
    );
};

export default ClassroomCanvasViewer;